<style scoped lang="scss">
</style>
<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/mixture/bom/page" getKey="rows"
      :columns="columns">
      <template #top>

      </template>
      <template #conditions>
        <el-form size="mini" :inline="true" class="demo-form-inline">
          <el-form-item :label="$t('yuanhunliaogongdan')" class="noborder">
            <el-input disabled v-model="$attrs.orderObj.no">
            </el-input>
          </el-form-item>
          <el-form-item :label="$t('yuanhunliaozhong')" class="noborder">
            <el-input disabled v-model="$attrs.orderObj.mixtureWeight">
            </el-input>
          </el-form-item>
          <el-form-item :label="$t('bencihunliaozhongliang')">
            <el-input  v-model="mixingWeight"  @blur="handleBlur">
            </el-input>
          </el-form-item>
          <el-form-item>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
<!--      <template #buttonsL>-->
<!--        <el-button size="mini" v-if="utils.checkPower('web_base_shift_item_create')" icon="yicon yicon-add_fill" @click="yt.showEditDialog('xinzeng',null,'w1')">-->
<!--          {{$t('xinzeng')}}-->
<!--        </el-button>-->
<!--      </template>-->
      <!-- 操作插槽 -->
      <template #bencibuliaoshuliang="scope">
        {{scope.row.repairQuantity}}
      </template>
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" v-if="utils.checkPower('web_base_shift_item_update')" @click="yt.showEditDialog('bianji', scope.row);calculationTimeLength(scope.row)">{{$t('bianji')}}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" :loading="yt.editObj.loading" v-if="utils.checkPower('web_base_shift_item_delete')" class="font-color-danger"
              @click="yt.remove(scope.row,'/web/setting/shift/delete')">{{$t('shanchu')}}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
      :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">


    </el-dialog>
  </div>
</template>

<script type="text/javascript">
  // import curd_data from '@/common/curd/curd_data';
  export default {
    name: 'web_supplement_materials_order',
    data() {
      return {
        mixingWeight:'',//本次混料重量
        columns: [{
          label: 'wuliaobianma',
          prop: 'material.code',
          width: 130,
        }, {
          label: 'wuliaomingcheng',
          prop: 'material.name',
        }, {
          label: 'guige',
          prop: 'material.spec',
        },  {
          label: 'yuanyongliaoshuliang',
          prop: 'quantity',
        }, {
          label: 'bencibuliaoshuliang',
          type: 'slot'
        }, {
          label: 'danwei',
          prop: 'unit',
        }],
        bomList:[],
        bomObject:null
      };
    },
    created() {
      setTimeout(() => {
        // table列表接口请求参数
        this.yt.conditions = {
          mixtureOrderId: this.$attrs.orderObj.id,
        }
        this.yt.get(1);

      }, 300)
    },
    methods: {
      handleBlur() {
        console.log('输入框失去焦点',this.mixingWeight);
        this.replenishDetail()
        this.yt.get(1, this.beforeReq, this.afterReq);
      },
      replenishDetail(){
        let params = {
          mixtureOrderId:this.$attrs.orderObj.id,
          quantity:this.mixingWeight
        }
        this.http
          .post('/web/mixture/order/replenishDetail', params)
          .then(res => {
            this.bomObject = res.data
            this.bomList=res.data.bomList
            this.utils.successMessage(this.$t(res.msg));
            setTimeout(() => {
              let list = this.yt.list;

              if (list.length > 0) {
                for (let i = 0; i < this.bomList.length; i++) {
                  for (let j = 0; j < list.length; j++) {
                    if (this.bomList[i]['id'] === list[j]['id']) {
                      this.$set(list[j],'repairQuantity',this.bomList[i]['repairQuantity'])
                    }
                  }
                }
              }
            }, 300);
          })
          .catch(msg => {
            this.utils.errorMessage(msg);
          })
      },



    },


  };
</script>
